import { useSelector } from 'react-redux'
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import SwallowIPForm from '../components/SwallowIPForm';


const SwallowIPAddPage = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                    {customization.login && (<SwallowIPForm />)}
            </Grid>
        </Grid>
    );
};

export default SwallowIPAddPage;